import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const HorizontalColoredLine = ({ color, margin = 20 }) => {
    const { theme } = useTheme();

    const lineColor = color || theme.colors.border;

    return (
        <hr
            style={{
                border: `1px solid ${lineColor}`,
                margin: `${margin}px 0`,
                // marginBottom: `${margin}px`,
                // marginTop: `${margin}px`,
                // marginBottom: `${margin}px`,
                // margin: `${margin}px 0 ${margin}px 0`,
                width: '100%',
            }}
        />
    );
};

export default HorizontalColoredLine;